<script setup>
import CFTicketModalInner from '#modules/support/components/Ticket/CFTicketModalInner.vue';
import CFButton from '@/ui/Button/CFButton.vue';
import { useTicketStore } from '#modules/support/stores/ticket.store.js';
import { shallowRef } from 'vue';
import CreateTicketStep from '#modules/support/components/Ticket/Steps/CreateTicketStep.vue';
import SelectDomainStep from '#modules/support/components/Ticket/Steps/SelectDomainStep.vue';
import ProductSelectStep from '#modules/support/components/Ticket/Steps/ProductSelectStep.vue';
import CFCircleBackButton from '@/shared/components/CFCircleBackButton.vue';
import CFTicketDomainItem from '#modules/support/components/Ticket/CFTicketDomainItem.vue';
import CFTicketSelectProductsWrapper from '#modules/support/components/Ticket/CFTicketSelectProductsWrapper.vue';

const ticketStore = useTicketStore();

const selectedDomain = shallowRef(null);

const setSelectedDomain = (domain, callback) => {
    selectedDomain.value = domain;
    callback(domain);
};

const goToCreateTicketStep = () => {
    ticketStore.setComponent(CreateTicketStep, SelectDomainStep, {
        domain: selectedDomain,
    });
};
</script>

<template>
    <CFTicketModalInner :title="$t('support.select_product')">
        <CFTicketSelectProductsWrapper
            :search-placeholder="$t('general.search_for_domain')"
            route="general/domains"
        >
            <template #item="{ item, selectedItem, onSelect }">
                <CFTicketDomainItem
                    :domain="item"
                    :selected-domain="selectedItem"
                    @select="setSelectedDomain(item, onSelect)"
                />
            </template>
        </CFTicketSelectProductsWrapper>

        <template #actions>
            <CFCircleBackButton @click="ticketStore.goToPrevious(ProductSelectStep)">
                {{ $t('button.back') }}
            </CFCircleBackButton>

            <CFButton
                type="button"
                :disabled="!selectedDomain"
                @click="goToCreateTicketStep"
            >
                {{ $t('button.next') }}
            </CFButton>
        </template>
    </CFTicketModalInner>
</template>
